import React from "react";

export const initialAppState = {};

const AppContext = React.createContext(initialAppState);

export default AppContext;
